import { pipe, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { User } from '@app/models/users/users.model';
import { Fetch } from '@app/models/fetch';
import { AuthState, UpdateUser } from '@app/auth/auth.state';
import { Store } from '@ngxs/store';
import { BatteryOrder } from '@app/models/battery/battery-order.model';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../../auth/auth.state";
import * as i3 from "@ngxs/store";
var UserService = /** @class */ (function () {
    function UserService(fetch, authState, store) {
        this.fetch = fetch;
        this.authState = authState;
        this.store = store;
    }
    UserService.prototype.update = function (id, body) {
        var _this = this;
        return this.fetch.patch('//users', id, body).pipe(switchMap(function () { return _this.authState.getUser(); }), switchMap(function (currUser) {
            if (id === currUser.id) {
                return _this.get().pipe(switchMap(function (newUser) { return _this.store.dispatch(new UpdateUser(newUser)); }));
            }
            return of(currUser);
        }));
    };
    UserService.prototype.changePassword = function (id, body) {
        return this.fetch.patch("//users/" + id + "/password", '', body);
    };
    UserService.prototype.changeEmail = function (id, body) {
        var _this = this;
        return this.fetch.patch("//users/" + id + "/email", '', body).pipe(switchMap(function () { return _this.authState.getUser(); }), switchMap(function (currUser) {
            if (id === currUser.id) {
                return _this.get().pipe(switchMap(function (newUser) { return _this.store.dispatch(new UpdateUser(newUser)); }));
            }
            return of(currUser);
        }));
    };
    UserService.prototype.get = function () {
        return this.fetch.getOne('//users', this.authState.userID()).model(User);
    };
    UserService.prototype.joinDevices = function (devices) {
        return this.get().pipe(map(function (user) {
            for (var i = 0; i < devices.length; i++) {
                if (devices[i].user_id === user.id) {
                    devices[i].user = user;
                }
            }
            return devices;
        }));
    };
    UserService.prototype.joinDevicesPipe = function () {
        var _this = this;
        return pipe(switchMap(function (devices) {
            if (devices.length === 0) {
                return of(devices);
            }
            return _this.joinDevices(devices);
        }));
    };
    UserService.prototype.joinNotifications = function (notifs) {
        return this.get().pipe(map(function (user) {
            for (var i = 0; i < notifs.length; i++) {
                if (notifs[i].user_id === user.id) {
                    notifs[i].user = user;
                }
            }
            return notifs;
        }));
    };
    UserService.prototype.joinNotificationsPipe = function () {
        var _this = this;
        return pipe(switchMap(function (notifications) {
            if (notifications.length === 0) {
                return of(notifications);
            }
            return _this.joinNotifications(notifications);
        }));
    };
    UserService.prototype.joinLocation = function (location) {
        return this.get().pipe(map(function (user) {
            location.user = user;
            return location;
        }));
    };
    UserService.prototype.joinLocations = function (locs) {
        return this.get().pipe(map(function (user) {
            for (var i = 0; i < locs.length; i++) {
                if (locs[i].user_id === user.id) {
                    locs[i].user = user;
                }
            }
            return locs;
        }));
    };
    UserService.prototype.joinLocationPipe = function () {
        var _this = this;
        return pipe(switchMap(function (loc) { return _this.joinLocation(loc); }));
    };
    UserService.prototype.joinLocationsPipe = function () {
        var _this = this;
        return pipe(switchMap(function (locations) { return _this.joinLocations(locations); }));
    };
    UserService.prototype.getUserEntitlement = function () {
        return this.get().pipe(map(function (user) { return user.plan.entitlement.toLowerCase(); }));
    };
    UserService.prototype.getUserEntitlementObject = function () {
        return this.get().pipe(map(function (user) { return user.plan; }));
    };
    // route for obtaining the purchase link for new batteries
    UserService.prototype.getPurchaseOptions = function (deviceID) {
        return this.fetch
            .get("//users/" + this.authState.userID() + "/devices/" + deviceID + "/purchase-options")
            .model(BatteryOrder);
    };
    UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.AuthState), i0.ɵɵinject(i3.Store)); }, token: UserService, providedIn: "root" });
    return UserService;
}());
export { UserService };
